module.exports = __webpack_public_path__ + "img/1_444@2x.5d7a3a60.png";